import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";

export const Intro = () => (
  <section data-testid="intro-section" className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-44">
    <div className="grid items-center gap-14 md:grid-cols-12 md:gap-10">
      <Reveal className="md:col-span-5">
        <div className="frame spot relative aspect-[4/5] overflow-hidden">
          <img src="/img/intro.webp" alt="Gold ring and pearl drop earrings on ivory silk — jewellery product photography" loading="lazy" className="h-full w-full object-cover" />
        </div>
        <p className="mt-4 text-xs uppercase tracking-[0.25em] text-muted-ink">Detail study — Creative Concept</p>
      </Reveal>
      <Reveal className="md:col-span-6 md:col-start-7" delay={0.15}>
        <p className="eyebrow text-wine">The Art of Intention</p>
        <h2 data-testid="intro-heading" className="mt-5 font-serif text-4xl font-light leading-[1.05] text-wine md:text-6xl">
          Every Detail <span className="italic">Tells a Story.</span>
        </h2>
        <div className="mt-10 max-w-lg space-y-5 text-base leading-relaxed text-charcoal/85 md:text-[1.05rem]">
          <p>At BWI, we believe beautiful content is never accidental.</p>
          <p>From the smallest jewellery detail to the perfect beauty shot, every frame is thoughtfully created to reflect the personality of your brand.</p>
          <p>We create visual experiences that make products feel desirable, memorable and meaningful.</p>
        </div>
        <Link to="/about" className="link-line mt-12" data-testid="intro-discover-btn">
          Discover BWI <ArrowRight size={14} strokeWidth={1.25} />
        </Link>
      </Reveal>
    </div>
  </section>
);
